import { useMemo } from 'preact/hooks'

import { checkConditions } from '@/components/helpers/metaobjects'

/**
 * Takes a criteria object to pass to checkConditions to validate what badges should display.
 */

export function useBadges(criteria) {
  return useMemo(() => {
    const data = GM_STATE.metaobjects.badges
    return data
      .filter((badge) => checkConditions(badge.conditions, criteria))
      .sort((a, b) => b.conditions?.priority - a.conditions?.priority)
  }, [])
}
